export default "__VITE_ASSET__CxfC8bz0__"